import { Store } from "@/store/store";
import CoverageService from "../CoverageService";
import errorManager from "@/modules/errors/error-services/error-manager";
import { ErrorMessage } from "@/models/ErrorMessage";
class AddressStore extends Store {
  data() {
    return {
      //THIS can be removed and te store vritten
      //street is house number plus street, because the street number is optional during the search and also in the google response
      street: "",
      city: "",
      state: "",
      postcode: "",
      country: "",
    };
  }

  getGeocoding(value) {
    console.log(value);
    return CoverageService.getGeocoding(value)
    .then(
      (response) => {
        console.log(response);
        return Promise.resolve(response.data.results || []);
      },
      (error) => {
        console.error(error);
        let catchError = error;
        if (error.response) {
          catchError = error.response;
        }
        this.pushGeocodingError(catchError);
        return errorManager.manage(
          catchError,
          errorManager.case("ServerError", ()=>{
            this.pushError(new ErrorMessage(error,"The geo request for coordinates search is not working",500));
            return Promise.reject([]);
          }),
          errorManager.case("Unauthorized", ()=>{
            this.pushError(new ErrorMessage(error,"The geo request for coordinates search is not authorized: ",401));
            return Promise.reject([]);
          }),
          errorManager.defaultCase(() => () => Promise.resolve([]))
        );
      }
    );
  }
  pushGeocodingError(catchError) {
    const status = catchError && catchError.data && catchError.data.error;
    if (status) {
      errorManager.pushError(
        new ErrorMessage(status.status, status.message, status.code)
      );
    }
  }
  reverseGeocoding(lat, lng) {
    return CoverageService.reverseGeocoding(lat, lng)
      .then((response) => response.data)

      .then(
        (response) => {
          console.log(response);
          return Promise.resolve(response.results || []);
        },
        (error) => {
          console.error(error);
          let catchError = error;
          if (error.response) {
            catchError = error.response;
          }
          this.pushGeocodingError(catchError);
          return errorManager.manage(
            catchError,
            errorManager.case("ServerError", ()=>{
              this.pushError(new ErrorMessage(error,"The geo request by coordinates search is not working",500));
              return Promise.reject([]);
            }),
            errorManager.case("Unauthorized", ()=>{
              this.pushError(new ErrorMessage(error,"The geo request by coordinates search is not authorized: ",401));
              return Promise.reject([]);
            }),
            errorManager.defaultCase(() => () => Promise.resolve([]))
          );
        }
      );
  }
}
export const addressStore = new AddressStore("ADDRESS");
